const document = {
    skOrganization: {
        icon: null,
        text: 'SK Organisasi Project',
        route: 'admin.project.sk-organization',
        role: {
            project: [ 'attendant' ],
        }
    },
    charter: {
        icon: null,
        text: 'Project Charter',
        route: 'admin.project.charter.list',
        role: {
            project: [ 'attendant' ],
        }
    },
    step: {
        icon: null,
        text: 'Detail Action Step',
        route: 'admin.project.action-steps',
        role: {
            project: [ 'attendant' ],
        }
    },
}

export default document
